import { render, staticRenderFns } from "./tableMdAndA.vue?vue&type=template&id=4dabcab3&scoped=true"
import script from "./tableMdAndA.vue?vue&type=script&lang=js"
export * from "./tableMdAndA.vue?vue&type=script&lang=js"
import style0 from "./tableMdAndA.vue?vue&type=style&index=0&id=4dabcab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dabcab3",
  null
  
)

export default component.exports